import { registerIcon } from "@ui5/webcomponents-base/dist/asset-registries/Icons.js";

const name = "discussion-2";
const pathData = "M422 0q38 0 64 26t26 64v300q0 12-8 19t-18 7-18-8l-84-89q-1 18-8.5 33T356 378.5t-28 18-34 6.5H139L44 504q-7 8-18 8-10 0-18-7t-8-19V186q0-38 26-64t64-26h38v-6q0-38 26-64t64-26h204zm39 90q0-17-11-28t-28-11H218q-17 0-28 11t-11 28v128q0 16 11 27t28 11h166q11 0 19 8l58 62V90zM294 352q17 0 28-11t11-27v-7H218q-38 0-64-26t-26-63v-71H90q-17 0-28 11t-11 28v236l58-62q8-8 19-8h166z";
const ltr = false;
const accData = null;
const collection = "SAP-icons-v5";
const packageName = "@ui5/webcomponents-icons";

registerIcon(name, { pathData, ltr, collection, packageName });

export default "SAP-icons-v5/discussion-2";
export { pathData, ltr, accData };